import store from "@/store";
import { clearReservationSearchDataSession } from "@/store/modules/reservationSearchData";
import { ShakenStorage } from "@/service/storage";

/**
 * HTTP 401を受けた時の利用者FE共通セッション終了処理。
 * サーバーへログアウトAPIを送らず、ローカル状態を破棄して対応するログイン画面を再読み込みする。
 */
export class SessionService {
  private static handlingUnauthorized = false;
  static handleUnauthorized() {
    if (SessionService.handlingUnauthorized) {
      return;
    }
    SessionService.handlingUnauthorized = true;

    const isUserScreen = window.location.href.indexOf("user") > -1;
    const tokenKey = isUserScreen ? "usertoken" : "factorytoken";
    const loginPath = isUserScreen ? "/user/login" : "/factory/login";
    // 認証コンテキストの削除は、他タブへのログアウト通知も兼ねる。
    // タブ間の判定・画面遷移は App.vue の認証コンテキスト監視に一元化する。
    ShakenStorage.removeAuth(isUserScreen ? "user" : "factory");
    ShakenStorage.removeReservationDetail(isUserScreen ? "user" : "factory");

    store.dispatch("Authentication/clearTimerRefeshToken");
    store.dispatch("Authentication/clearState");
    window.localStorage.removeItem(tokenKey);
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("kyotenCd");
    window.localStorage.removeItem("reservation-detail");
    clearReservationSearchDataSession();

    // Vuexに残る業務データを確実に破棄するため、対応するログイン画面を再読み込みする。
    window.location.replace(loginPath);
  }

  static handleSessionRefreshTimeout() {
    SessionService.setConnectionProblem("timeout");
  }

  static setConnectionProblem(reason: string) {
    store.dispatch("Authentication/setSessionConnectionProblem", reason);
  }

  static clearConnectionProblem() {
    store.dispatch("Authentication/clearSessionConnectionProblem");
  }

  static hasConnectionProblem(): boolean {
    return !!store.getters["Authentication/sessionConnectionProblem"];
  }
}
